export default "__VITE_ASSET__2854f9f6__"